module.exports = __webpack_public_path__ + "img/storyset-to-do-list-rafiki.0553a93e.svg";